import React from 'react'
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  UncontrolledTooltip,
  TabContent,
  TabPane,
  Badge,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap'
import SelectAsyncComponent from '../../../../..//componentes/select/select-async.component'
import CheckBox from '../../../../../componentes/checkbox/checkbox.component'
import JustificativaComponent from '../../../../../componentes/justificativa/justificativa.component'
import classnames from 'classnames'
import * as acessos from '../../../../../acessos.const.util'
import SelectComponent from '@componentes/select/select.component';

const BlocoPage = props => {
  return (
    <React.Fragment>
      <JustificativaComponent
        isOpen={props.showModalJustificativa}
        toggle={props.toggleModalJustificativa}
        setJustificativa={props.setJustificativa}
        justificativa={props.justificativa}
        onClick={props.removerBlocoLista}
        title='Exclusão de Bloco'
        label='Justificativa da Exclusão'
        btnText='Confirmar Exclusão'
        placeholder='Justificativa para a exclusão'
      />
      <div className='mv-requisicao-congelacao-page'>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: props.activeTab === '1' })}
              onClick={() => {
                props.onChangeTab('1')
              }}
            >
              {props.blocoText} {props.blocoId && ` (${props.blocoId})`}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ position: 'relative' }}
              className={classnames({ active: props.activeTab === '2' })}
              onClick={() => {
                props.onChangeTab('2')
                props.limparCampos()
              }}
            >
              Listar Blocos{' '}
              <Badge className='count-blocos' style={{ right: -10 }}>
                {props.listarBlocos ? props.listarBlocos.length : 0}
              </Badge>
            </NavLink>
          </NavItem>
        </Nav>
        <br />
        <TabContent activeTab={props.activeTab}>
          <TabPane tabId='1'>
            <Row>
              <Col>
                <FormGroup>
                  <Label>Frascos:</Label>
                  <SelectComponent
                    isMulti
                    onChange={e => props.onChangeFrasco(e)}
                    options={props.frascos}
                    placeholder='Selecionar frasco'
                    value={props.frasco}
                    disabled={!props.laudoIsValido || props.blocoId}
                  />
                </FormGroup>
              </Col>
              <Col sm={3}>
                <FormGroup>
                  <Label>Número de cassetes:</Label>
                  <Input
                    value={props.numeroBlocos}
                    onChange={e => props.onChangeNumeroBlocos(e.target.value)}
                    name='numeroBlocos'
                    type='number'
                    min='1'
                    max='10'
                    disabled={!props.laudoIsValido || props.blocoId}
                  />
                </FormGroup>
              </Col>
              <Col sm={3}>
                <FormGroup>
                  <Label>Fragmentos por cassete:</Label>
                  {props.variosFragmentos && (
                    <Input
                      value={'N/D'}
                      name='numeroFragmentos'
                      type='text'
                      disabled={props.variosFragmentos}
                    />
                  )}
                  {!props.variosFragmentos && (
                    <Input
                      value={props.numeroFragmentos}
                      onChange={e =>
                        props.onChangeNumeroFragmentos(e.target.value)
                      }
                      name='numeroFragmentos'
                      type='number'
                      min='1'
                      max='10'
                      disabled={!props.laudoIsValido}
                    />
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              {!props.blocoId && (
                <React.Fragment>
                  <Col sm={'auto'}>
                    <FormGroup style={{ marginTop: '3px' }}>
                      <CheckBox
                        label='Vários fragmentos?'
                        name='checkVariosFragmentos'
                        disabled={!props.laudoIsValido}
                        onChange={e =>
                          props.onChangeVariosFragmentos(e.target.checked)
                        }
                        checked={props.variosFragmentos}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup style={{ margin: '3px 0px 20px 0px' }}>
                      <CheckBox
                        label='Novos cortes'
                        name='checkNovosCortes'
                        onChange={e =>
                          props.onChangeCheckNovosCortes(e.target.checked)
                        }
                        checked={props.novoscortes}
                        disabled={!props.laudoIsValido}
                      />
                    </FormGroup>
                  </Col>
                </React.Fragment>
              )}
              <Col>
                <FormGroup style={{ margin: '3px 0px 20px 0px' }}>
                  <CheckBox
                    label='Coloração'
                    name='checkColoracao'
                    onChange={e =>
                      props.onChangeCheckColoracao(e.target.checked)
                    }
                    checked={props.coloracao}
                    disabled={!props.laudoIsValido}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup style={{ margin: '3px 0px 20px 0px' }}>
                  <CheckBox
                    label='Antígeno'
                    name='checkAntigeno'
                    onChange={e =>
                      props.onChangeCheckAntigeno(e.target.checked)
                    }
                    checked={props.antigeno}
                    disabled={!props.laudoIsValido}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                {
                  <FormGroup
                    style={{ display: props.coloracao ? 'block' : 'none' }}
                  >
                    <Label>Colorações:</Label>
                    <SelectComponent
                      isMulti
                      onChange={e => props.onChangeSelecaoColoracao(e)}
                      options={props.coloracoes}
                      placeholder='Selecione as colorações'
                      value={props.coloracaoSelecionada}
                      disabled={!props.laudoIsValido}
                    />
                  </FormGroup>
                }
              </Col>
            </Row>
            <Row>
              <Col>
                {
                  <FormGroup
                    style={{ display: props.antigeno ? 'block' : 'none' }}
                  >
                    <Label>Antígeno:</Label>
                    <SelectComponent
                      isMulti
                      onChange={e => props.onChangeSelecaoAntigeno(e)}
                      options={props.antigenos}
                      placeholder='Selecione os antígenos'
                      value={props.antigenoSelecionado}
                      disabled={!props.laudoIsValido}
                    />
                  </FormGroup>
                }
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label>Material:</Label>
                  <SelectComponent
                    onChange={e => props.onChangeSelecaoMaterial(e)}
                    options={props.materiais}
                    placeholder='Selecionar material'
                    value={props.material}
                    disabled={!props.laudoIsValido}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup check>
                  <Label check style={{ userSelect: 'none' }}>
                    <Input
                      type='radio'
                      name='sentinela'
                      onClick={() => {
                        props.updateValorSentinela('sentinelaMelanoma')
                      }}
                      checked={props.sentinelaMelanoma}
                    />{' '}
                    Sentinela melanoma
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Label check style={{ userSelect: 'none' }}>
                    <Input
                      type='radio'
                      name='sentinela'
                      onClick={() => {
                        props.updateValorSentinela('sentinelaMama')
                      }}
                      checked={props.sentinelaMama}
                    />{' '}
                    Sentinela mama
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <FormGroup>
                  <Label>Técnico congelação:</Label>
                  <SelectAsyncComponent
                    options={props.medicoTecnico}
                    value={props.tecnico}
                    onChange={e => props.onChangeTecnico(e)}
                    placeholder='Selecionar técnico'
                    disabled={!props.laudoIsValido}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label>Médico congelacao:</Label>
                  <SelectAsyncComponent
                    options={props.medicoCongelacao}
                    value={props.medico}
                    onChange={e => props.onChangeMedico(e)}
                    placeholder='Selecionar médico'
                    disabled={!props.laudoIsValido}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label>Anotações</Label>
                  <Input
                    type='textarea'
                    value={props.anotacoes}
                    onChange={e =>
                      props.onChangeAnocacoes(e.currentTarget.value)
                    }
                    disabled={!props.laudoIsValido}
                  />
                </FormGroup>
              </Col>
            </Row>
            <footer>
              {props.laudoIsValido && (
                <Button color='danger' onClick={() => props.limparCampos()}>
                  Limpar campos
                </Button>
              )}
              <Button
                color='primary'
                disabled={
                  (!props.laudoIsValido && props.frasco === null) ||
                  props.material === null ||
                  props.medico === null ||
                  props.tecnico === null
                }
                onClick={e =>
                  props.blocoText.indexOf('Adicionar') > -1
                    ? props.adicionarBloco(e)
                    : props.editarBlocoId(e)
                }
              >
                {props.blocoText}
              </Button>
            </footer>
          </TabPane>
          <TabPane tabId='2'>
            <div className='responsive'>
              <table className='table'>
                <thead>
                  <tr>
                    <th>Solicitante</th>
                    <th>Bloco</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {props.listarBlocos &&
                    props.listarBlocos.length > 0 &&
                    props.listarBlocos.map((bloco, i) => {
                      return (
                        <tr key={bloco.idLaudoBloco}>
                          <td>{bloco.nomeMedico}</td>
                          <td>
                            {bloco.numeroBloco} {` (${bloco.idLaudoBloco})`}
                          </td>

                          <td width={15}>
                            <Col>
                              {props.acessoPermitido(
                                props.usuario,
                                acessos.EditarBlocoseLaminasCongelacao
                              ) && (
                                <Button
                                  className='editar-cassete'
                                  color='link'
                                  id={'editar_' + bloco.i}
                                  onClick={() =>
                                    props.editarBloco(bloco.idLaudoBloco)
                                  }
                                >
                                  <i
                                    style={{
                                      fontSize: 13,
                                      float: 'left'
                                    }}
                                    className='fas fa-edit fa-2x'
                                  ></i>
                                  <UncontrolledTooltip
                                    placement='top'
                                    target={'editar_' + bloco.id}
                                  >
                                    Editar
                                  </UncontrolledTooltip>
                                </Button>
                              )}
                            </Col>
                          </td>
                          <td>
                            <Col>
                              {(props.acessoPermitido(
                                props.usuario,
                                acessos.ApagarBlocos
                              ) ||
                                props.acessoPermitido(
                                  props.usuario,
                                  acessos.ApagarBlocoseLaminasCongelacao
                                )) && (
                                <Button
                                  className='editar-cassete'
                                  color='link'
                                  id={'excluir_' + bloco.idLaudoBloco}
                                  onClick={() =>
                                    props.apagarBlocoJustificativa(
                                      bloco.idLaudoBloco
                                    )
                                  }
                                >
                                  <i
                                    style={{
                                      fontSize: 13,
                                      float: 'right'
                                    }}
                                    className='fas fa-trash fa-2x'
                                  ></i>
                                  <UncontrolledTooltip
                                    placement='top'
                                    target={'excluir_' + bloco.idLaudoBloco}
                                  >
                                    Excluir
                                  </UncontrolledTooltip>
                                </Button>
                              )}
                            </Col>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>
            {/* </div> */}
          </TabPane>
        </TabContent>
      </div>
    </React.Fragment>
  )
}

export default BlocoPage



// WEBPACK FOOTER //
// ./src/app/common/requisicaoCongelacao/tabs/bloco/bloco.page.js